import React,{useState, useEffect, useRef}	from "react";
import { InputGroup, Form}			from "react-bootstrap";
import {Link}						from "react-router-dom";
import {sortByDate, norm}					from  "../utils/functions";
import authApi						from "../utils/authApi";

import atlasApi from "../utils/atlasapi";
import { MagnifyingGlass, ArrowSquareOut} from "@phosphor-icons/react";

export default function ProjectQuickSearch({value, options, onClick}) {


	const [data,setData]				= useState(null);
	const [results,setResults]			= useState(null);
	const [activeIndex, setActiveIndex] = useState(0);
	const linksRef = useRef([]);

	useEffect(() => {
		fetchData();
	}, []);	
	const setActive = (index) => {
		setActiveIndex(index);
	};
	const handleClick = (index) => {
		setActive(index);
	};
	const fetchData = ()=>{
		
		if(data)
			return;
		
		Promise.all([
			atlasApi.getToken()
		])
		.then((res) => {
			console.log(atlasApi.username);
			if(atlasApi.username)
				return res;
			else
				return Promise.all([authApi.getUser()]);
		})
		.then((res) => {
			const dataRequests = [
				atlasApi.getProjectsMini()
			];
			
			return Promise.all(dataRequests);

		})
		.then((res) => {
			
			const projects = JSON.parse(res[0]);
			projects.sort((a,b)=>{return sortByDate(b,a,row=>row.lastUpdate)});
		
			setData(projects);
		 
		}).catch((e)=>{
			
		});
		return;
	};
	const searchNeedle = (needle, item) => {
		
		if(needle.length < 3)
			return true;
		
		const regex =new RegExp(norm(needle), "i");
		
		/* we use search now, therefor the >-1 condition, eventualy we can use regexp for boolean and search ranking*/
		return 	(item.name && norm(item.name).match(regex, "i"))
	}
	const search = (a) => {
		
		if(a.target.value.length<3) {
			setResults(null);
			return;
		}
		
		const r = data.filter((item, index)=>{

			return searchNeedle(a.target.value, item);
		}).slice(0,10);
		setResults(r);
	}
	
	const handleKeyDown = (e) => {
		if (e.key === "ArrowDown") {
			e.preventDefault();
			setActive((activeIndex + 1) % linksRef.current.length);
		}

		if (e.key === "ArrowUp") {
			e.preventDefault();
			setActive(
				(activeIndex - 1 + linksRef.current.length) %
				linksRef.current.length
			);
		}

		if (e.key === "Enter") {
			linksRef.current[activeIndex]?.click();
		}
	};
	
	const handleClose = () => {
		
		setTimeout(()=>{
			setResults(null);
		}, 200);
		
		
	}
	
	if(!data)
		return;
	
	
	return (
		<div className="project-quick-search" onKeyDown={handleKeyDown} onBlur={handleClose}>
			<InputGroup className="search-wrp">
				<Form.Control  type="text" className="search-input" onChange={search} placeholder="Search projects..." />
				<InputGroup.Text id="basic-addon1"><MagnifyingGlass weight="bold" size={16} /></InputGroup.Text>
			</InputGroup>
			
			{results && !!results.length &&
			<div id="project-quick-search-results" className="results">
				{
					results.map((p, index)=>{
						return (
							<a 
								key={index}
								ref={(el) => (linksRef.current[index] = el)}
								className={index === activeIndex ? "active" : ""}
								href={"/pages/project/"+p.projectid}
							>
							<span>{p.name}</span> <ArrowSquareOut weight="bold" size={16} />
							
							</a>
						)
					})
				}
			</div>
			}
			{results && !results.length &&
			<div className="no-results">
				no results
			</div>
			}
		</div>
	);
}